import React from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';

export function OrderSuccess() {
    var getParams = function (url) {
        var params = {};
        var parser = document.createElement('a');
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
              var pair = vars[i].split('=');
              params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    };
    const orderCode = DOMPurify.sanitize(getParams(window.location.href).order_code);
    return (
        <section id="OrderSuccess">
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Request is submitted successfully</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-8 offset-md-2">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        <div className="theme-color text-center">
                                            <img src="./images/sent_ico.png" width="100" alt="" className="mb-4" />
                                            <p className="theme-color fw-bold">Request ID: {orderCode}</p>

                                            <p className="theme-color">
                                                We have received your request and we'll be in touch soon. <br />Alternatively, you may click <Link to={'/login'} target="_self"><b><u>here</u></b></Link> to login to view your request detail with the Request ID.
                                            </p>
                                            <p className="des-py-success"> A confirmation email will be sent to you shortly.</p>
                                            <p className="des-py-success"> For Government Records, you will receive an additional email asking for further information. 
Your request will be processed only after we have received your reply.</p>
                                        </div>
                                        <div className="text-center mt-3">

                                            <Link to={'/'} className="btn btn-primary">Back to
                                                Home</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





